import { ERROR_CODE as u } from "../../constants/error.js";
import { useConfigContext as c } from "../../contexts/config/ConfigContext.js";
import { CustomError as m } from "../../errors/customError.js";
import { fetchRss as R } from "../../static/rss/fetchRss.js";
import { useSuspenseQuery as a } from "@tanstack/react-query";
import * as d from "ramda";
import { useCallback as p } from "react";
const I = (t) => {
  const {
    url: e,
    deserialize: r
  } = t, {
    config: o
  } = c(), i = p(() => {
    const {
      fetchRss: s
    } = o;
    if (d.isNil(s))
      throw new m('config "fetchRss" is not defined', u.GENERAL.MISSING_CONFIG);
    return s.buildId;
  }, [o]), {
    data: n,
    isLoading: f
  } = a({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [e],
    queryFn: () => R(i(), e, r)
  });
  return {
    data: n,
    isLoading: f
  };
};
export {
  I as default
};
//# sourceMappingURL=useReactQuerySuspenseFetchRss.js.map
